import { Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
	container: {
		'& h5': {
			marginRight: '8px !important',
		},
		alignItems: 'center',
		display: 'flex',
		width: '100%',
	},
	spaceBetween: {
		justifyContent: 'space-between',
	},
}));

interface Props {
	label: string;
	value?: string | number;
	className?: string;
	spaceBetween?: boolean;
}

export function LabelField({ className, label, spaceBetween, value }: Props) {
	const classes = useStyles();

	return (
		<div
			className={clsx(classes.container, className, {
				[classes.spaceBetween]: spaceBetween,
			})}
		>
			<Typography variant={'h5'}> {label}: </Typography>

			<Typography variant={'h6'}> {value} </Typography>
		</div>
	);
}
